export const spellWord = (value: string) => {
    const reg = /([\u0E00-\u0E7F]+)/

    if (reg.test(value)) {
        const string = value.slice(0, value.length - 1)

        return string
    } else {
        return value
    }
}
